import React from "react";
import { Button } from "./button";
import { Share2 } from "lucide-react";
import { Facebook, Twitter, Linkedin } from "lucide-react";

const ShareComponent = ({ blog }) => {
  const url = window.location.href;
  const shareOptions = [
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        window.location.href
      )}`,
      color: "text-blue-600",
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        window.location.href
      )}&text=${encodeURIComponent(blog.title)}`,
      color: "text-blue-400",
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        window.location.href
      )}`,
      color: "text-blue-700",
    },
  ];

  const sharePost = () => {
    if (navigator.share) {
      navigator.share({
        title: title,
        url: url,
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground mr-2">Share:</span>
      {shareOptions.map((option) => (
        <Button key={option.name} variant="ghost" size="icon" asChild>
          <a
            href={option.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Share on ${option.name}`}
            className={option.color}
          >
            <option.icon className="w-4 h-4" />
          </a>
        </Button>
      ))}
      <Button variant="ghost" size="icon" onClick={sharePost}>
        <Share2 className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default ShareComponent;
